import { useRef } from "react";

export const useSpiderfy = (map) => {
    const spiderLinesRef = useRef(new Map());
    const spiderGroupRef = useRef([]);
    const spiderfiedRef = useRef(false);

    const clearLine = (marker) => {
        const line = spiderLinesRef.current.get(marker);
        if (line) line.setMap(null);
    };

    const setLine = (marker, path, color = "#000") => {
        clearLine(marker);

        const poly = new google.maps.Polyline({
            path,
            strokeColor: color,
            strokeOpacity: 0.9,
            strokeWeight: 2,
            map
        });

        spiderLinesRef.current.set(marker, poly);
    };

    const spiderfy = (group) => {
        const projection = map.getProjection();
        if (!projection || group.length <= 1) return;

        spiderGroupRef.current = group;

        const center = group[0].getPosition();
        const world = projection.fromLatLngToPoint(center);

        const angleStep = (Math.PI * 2) / group.length;
        const radius = 0.00005 * Math.pow(2, 20 - map.getZoom());

        group.forEach((marker, i) => {
            const angle = i * angleStep;

            const px = world.x + radius * Math.cos(angle);
            const py = world.y + radius * Math.sin(angle);

            const newPos = projection.fromPointToLatLng({ x: px, y: py });

            const origin = marker.getPosition();

            marker.setPosition(newPos);
            setLine(marker, [origin, newPos], "#000");
        });

        spiderfiedRef.current = true;
    };

    const unspiderfy = (markersRef, originalPosRef) => {
        markersRef.current.forEach((marker, index) => {
            const original = originalPosRef.current.get(index);
            if (original) marker.setPosition(original);
        });

        spiderLinesRef.current.forEach(line => line.setMap(null));
        spiderLinesRef.current.clear();

        spiderGroupRef.current = [];
        spiderfiedRef.current = false;
    };

    const setHoverLine = (marker) => {
        const poly = spiderLinesRef.current.get(marker);
        if (poly) poly.setOptions({ strokeColor: "#ff0000" });
    };

    const resetHoverLine = (marker) => {
        const poly = spiderLinesRef.current.get(marker);
        if (poly) poly.setOptions({ strokeColor: "#000000" });
    };

    return {spiderfy, unspiderfy, setHoverLine, resetHoverLine, spiderfiedRef};
};